import { render, staticRenderFns } from "./deleteProduct.vue?vue&type=template&id=5916ce2e&scoped=true&"
import script from "./deleteProduct.vue?vue&type=script&lang=js&"
export * from "./deleteProduct.vue?vue&type=script&lang=js&"
import style0 from "./deleteProduct.vue?vue&type=style&index=0&id=5916ce2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5916ce2e",
  null
  
)

export default component.exports